<form class="ul-form filters">
  @for (filter of filters(); track filter.id) {
    @if (filter.type === 'string') {
      @let placeholder = filter.defaultValueKey | translate;
      <mat-form-field
        appearance="outline"
        class="ul-single-line-input string-filter"
        id="filter-form-field-{{ filter.id }}"
      >
        <input
          class="ul-textbox"
          type="text"
          matInput
          [formField]="form[filter.id]"
          [placeholder]="placeholder"
        />
        @if (form[filter.id]().value()) {
          <button
            matSuffix
            comp-button="secondary"
            size="medium"
            [iconOnly]="true"
            type="button"
            aria-label="Clear"
            (click)="clearFilter(filter.id); $event.stopPropagation()"
          >
            <i comp-icon size="medium">close</i>
          </button>
        }
      </mat-form-field>
    } @else if (filter.type === 'enum') {
      <mat-form-field appearance="outline" class="ul-single-line-input fixed-filter">
        <mat-select
          [formField]="form[filter.id]"
          placeholder="{{ filter.defaultValueKey | translate }}"
        >
          <mat-option value="">{{ filter.defaultValueKey | translate }}</mat-option>

          @for (kv of getEnumIdentifiers(filter); track kv[0]) {
            @let key = kv[0];
            @let value = kv[1];
            @if (filter.keyTemplate) {
              <mat-option [value]="[value]">{{
                filter.keyTemplate! + value | translate
              }}</mat-option>
            } @else {
              <mat-option [value]="key">{{ value }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    } @else if (filter.type === 'columns') {
      <div class="button-container">
        <button
          matSuffix
          comp-button="secondary"
          size="medium"
          [iconOnly]="true"
          type="button"
          [matMenuTriggerFor]="columnsMenu"
          aria-label="Select columns"
          class="menu-button"
          (click)="$event.stopPropagation()"
        >
          <i comp-icon size="medium">tune</i>
        </button>
        <div
          aria-atomic="true"
          aria-live="polite"
          class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align"
        >
          <div class="mat-mdc-form-field-hint-wrapper">
            <div class="mat-mdc-form-field-hint-spacer"></div>
          </div>
        </div>
      </div>
      <mat-menu #columnsMenu="matMenu" class="columns-filter-menu-panel">
        <div class="columns-filter-menu-content" (click)="$event.stopPropagation()">
          @for (column of getColumnOptions(filter); track column.id) {
            <mat-checkbox
              class="columns-filter-checkbox"
              [checked]="isColumnSelected(filter, column.id)"
              (change)="toggleColumn(filter, column.id, $event.checked)"
            >
              {{ column.labelKey | translate }}
            </mat-checkbox>
          }
        </div>
      </mat-menu>
    }
  }
</form>
